<template>
  <div class="process-landing">
    <div class="inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OuterLandingWrapper'
  };
</script>

<style scoped lang="scss">
  .process-landing {
    background-color: #e5e5e5;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 2vw 0 !important;
    min-width: 320px;

    .inner {
      position: relative;
      background-color: #fff;
      max-width: 800px;
      padding: 35px 5vw;
      box-sizing: border-box;
      margin: auto 0;
      min-width: 320px;
      width: 100%;
    }
  }
</style>
